import type { NodeProps } from '@xyflow/react'
import { BaseNode } from 'uikit/graphs/default'
import type { BusinessEntityType, NetworkNodeData } from '../types'
import { getNodeTypeConfig } from '../constants'
import placeholderIcon from '../../assets/nodes/image-placeholder.svg'
import { cn } from 'utils/classnames'
import styles from './nodes.module.scss'

const DARK_BACKGROUND_TYPES: BusinessEntityType[] = ['TWITTER']

const HOST_BADGE_TYPES: BusinessEntityType[] = ['AIRBNB_HOST', 'BOOKING_HOST', 'VRBO_HOST', 'ENS_PROFILE']
const LISTING_BADGE_TYPES: BusinessEntityType[] = ['AIRBNB_LISTING', 'BOOKING_LISTING', 'VRBO_LISTING']

function getBadgeIconClass(nodeType: BusinessEntityType): string | undefined {
  if (HOST_BADGE_TYPES.includes(nodeType)) return styles.hostBadgeIcon
  if (LISTING_BADGE_TYPES.includes(nodeType)) return styles.listingBadgeIcon
  return undefined
}

export function SourceNode({ data, selected }: NodeProps) {
  const nodeData = data as NetworkNodeData
  const { nodeType } = nodeData

  const icon = getNodeTypeConfig(nodeType).icon ?? placeholderIcon
  const disabledClass = DARK_BACKGROUND_TYPES.includes(nodeType) ? styles.disabledOpacity : styles.disabledGrayscale
  const badgeClass = getBadgeIconClass(nodeType)

  return (
    <BaseNode
      selected={selected}
      nodeData={nodeData}
      isConnectable={nodeData.isConnectable}
      className={cn(badgeClass && styles.overflowVisible)}
      disabledClassName={disabledClass}
      labelClassName={styles.labelMaxWidth}
    >
      <img src={icon} alt={nodeType} className={badgeClass ?? styles.nodeIcon} />
    </BaseNode>
  )
}
